import Swal from 'sweetalert2'
import { NavLink, useNavigate } from 'react-router-dom'
import { AuthData } from '../../auth/AuthWrapper'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import LogoutIcon from '@mui/icons-material/Logout'
import { formatIndianNumber } from '../lib/formatIndianNumber'
import {
  selectTopHeaderText,
  selectUserData,
  selectTotalChips,
  selectTotalCash,
  selectProfileImage
} from '../../redux/features/common/selectors'
import { fetchAppData } from '../../redux/features/common/commonSlice'

export const NavBarTop = () => {
  const dispatch = useDispatch()
  const headerText = useSelector(selectTopHeaderText)
  const userData = useSelector(selectUserData)
  const totalChips = useSelector(selectTotalChips)
  const totalCash = useSelector(selectTotalCash)
  const profileImage = useSelector(selectProfileImage)
  const navigate = useNavigate()
  const { logout } = AuthData()

  // After profile edit, userData.update changes — refresh header balances/image once
  useEffect(() => {
    if (userData?.update) {
      dispatch(fetchAppData({ force: true }))
    }
  }, [userData?.update, dispatch])

  const handleLogout = e => {
    e?.preventDefault?.()
    e?.stopPropagation?.()
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to logout',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!',
      heightAuto: false
    }).then(async result => {
      if (result.isConfirmed) {
        await logout()
        navigate('/login')
        Swal.fire('Logout!', 'You have been logged out.', 'success')
      }
    })
  }

  return (
    <>
      <nav
        className='navbar navbar-top navbar-expand-md navbar-dark'
        id='navbar-main'
      >
        <div className='container-fluid'>
          <a className='h4 mb-0 text-dark text-uppercase d-none d-lg-inline-block'>
            {headerText}
          </a>
          <div className='d-flex align-items-center ml-auto mr-3'>
            <div className='text-dark font-weight-bold mr-4'>
              💰 Total Chips: {formatIndianNumber(totalChips)}
            </div>
            <div className='text-dark font-weight-bold'>
              💵 Total Cash: {formatIndianNumber(totalCash)}
            </div>
          </div>
          <ul className='navbar-nav align-items-center d-none d-md-flex'>
            <li className='nav-item dropdown'>
              <a
                className='nav-link pr-0'
                href='#'
                role='button'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
              >
                <div className='media align-items-center'>
                  <span className='avatar avatar-sm rounded-circle'>
                    <img
                      alt='Image placeholder'
                      src={
                        profileImage
                          ? profileImage
                          : './assets/img/theme/team-4-800x800.jpg'
                      }
                    />
                  </span>
                  <div className='media-body ml-2 d-none d-lg-block'>
                    <span className='mb-0 text-sm  font-weight-bold text-dark'>
                      {userData?.userName}
                    </span>
                  </div>
                </div>
              </a>
              <div className='dropdown-menu dropdown-menu-arrow dropdown-menu-right'>
                <div className=' dropdown-header noti-title'>
                  <h6 className='text-overflow m-0'>Welcome!</h6>
                </div>
                <NavLink
                  activeclassname='active'
                  to={'/edit-profile'}
                  className='dropdown-item'
                >
                  <i className='ni ni-single-02' />
                  <span>My profile</span>
                </NavLink>
                <div className='dropdown-divider' />
                <a
                  href='#'
                  onClick={handleLogout}
                  className='dropdown-item cursor'
                >
                  <LogoutIcon />
                  <span>Logout</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </>
  )
}
